import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "transfers";

export class TransferService {
  async createTransfer(data) {
    try {
      const res = await axios.post(`${apiUrl}`, data, { withCredentials: true });
      const result = res.data;
      if (!result.success) {
        throw new Error(result.message || "Failed to create transfer");
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getTransfers(params = {}) {
    try {
      const res = await axios.get(`${apiUrl}`, {
        params,
        withCredentials: true,
      });
      const result = res.data;
      if (!result.success) {
        throw new Error(result.message || "Failed to get transfers");
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getTransfer(id) {
    try {
      const res = await axios.get(`${apiUrl}/${id}`, { withCredentials: true });
      const result = res.data;
      if (!result.success) {
        throw new Error(result.message || "Failed to get transfer");
      }
      return result;
    } catch (error) {
      throw error;
    }
  }
}
